<template>
    <div class="main">
        <myheader></myheader>
        <div class="header">
            <div class="newLogo">
                <div class="icon">
                    <img src="/static/images/logos.jpg" alt="">
                </div>
                <div class="text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="95" height="24" viewBox="0 0 95 24" fill="none">
                <path d="M2.58594 19.2656H8.04688V17.7891H2.58594V19.2656ZM3.47656 8.46094H2.58594V13.3594C3.17969 12.6562 3.47656 11.6094 3.47656 10.2188V8.46094ZM4.88281 3.96094V6.11719H5.75V3.96094H4.88281ZM8.04688 11.8828V8.46094H7.10938V11.6016C7.15625 11.8047 7.22656 11.9141 7.32031 11.9297H7.74219C7.91406 11.9297 8.01562 11.9141 8.04688 11.8828ZM4.88281 8.46094V10.2422C4.86719 12.1328 4.41406 13.5469 3.52344 14.4844C3.33594 14.2656 3.02344 14 2.58594 13.6875V15.6328H8.04688V13.3828H7.15625C6.46875 13.3828 6.04688 13.1875 5.89062 12.7969C5.78125 12.5312 5.72656 12.1406 5.72656 11.625V8.46094H4.88281ZM13.9531 6.91406V8.17969H18.7344V6.91406H13.9531ZM13.9531 3.72656V4.99219H18.7344V3.72656H13.9531ZM17.6797 20.25H22.25V22.5703H10.7656V20.25H15.1484V18.2812H11.6797V16.1016H15.1484V14.3438H12.6172C12.3047 14.8594 11.9141 15.3672 11.4453 15.8672C11.1953 15.6641 10.8125 15.4062 10.2969 15.0938V22.5938H8.04688V21.4688H2.58594V22.9219H0.40625V6.11719H2.98438V3.96094H0.171875V1.59375H10.3906V3.96094H7.64844V6.11719H10.2969V13.9688C11.0781 12.9688 11.6719 11.7812 12.0781 10.4062L14.1875 10.875C14.0781 11.2656 13.9297 11.6875 13.7422 12.1406H15.1484V10.3125H11.4688V1.59375H21.2891V10.3125H17.6797V12.1406H21.6641V14.3438H17.6797V16.1016H21.2656V18.2812H17.6797V20.25Z" fill="#333333"/>
                <path d="M45.9922 6.46875H36.4062V9H43.9766V17.1094C43.9766 18.3438 43.6562 19.1641 43.0156 19.5703C42.9219 19.6328 42.8203 19.6875 42.7109 19.7344C41.9453 20.0469 40.5234 20.2031 38.4453 20.2031C38.3203 19.3281 38 18.3906 37.4844 17.3906C38.2812 17.4219 39.2812 17.4375 40.4844 17.4375C40.8125 17.4219 40.9844 17.2969 41 17.0625V11.7891H36.4062V23.1094H33.4297V11.7891H29.2344V20.2031H26.3516V9H33.4297V6.46875H24.1016V3.70312H33.4062V0.585938H36.4531V3.70312H45.9922V6.46875Z" fill="#333333"/>
                <path d="M64.0625 8.76562V5.69531H62.2344V8.76562H64.0625ZM64.0625 14.3438V11.2969H62.2344V14.3438H64.0625ZM53.9844 11.2969V14.3438H55.7188V11.2969H53.9844ZM59.8672 11.2969H58.0859V14.3438H59.8672V11.2969ZM58.0859 8.76562H59.8672V5.69531H58.0859V8.76562ZM53.9844 5.69531V8.76562H55.7188V5.69531H53.9844ZM51.4531 8.76562V7.03125C50.8281 7.625 50.3594 8.03906 50.0469 8.27344C49.3281 7.58594 48.5547 6.96094 47.7266 6.39844C49.4297 5.28906 50.8672 3.78906 52.0391 1.89844C52.2891 1.49219 52.5078 1.08594 52.6953 0.679688L55.4609 1.47656C55.2266 1.99219 54.9219 2.55469 54.5469 3.16406H68.9375V5.69531H66.6875V8.76562H69.8047V11.2969H66.6875V14.3438H69.4531V16.8984H48.6172V14.3438H51.4531V11.2969H48.2422V8.76562H51.4531ZM50.7266 23.1094L48.0078 22.0078C48.9922 21.0547 49.8125 19.7344 50.4688 18.0469C50.5625 17.8125 50.6406 17.5938 50.7031 17.3906L53.4453 18.0703C52.8672 20.0547 52.0078 21.6797 50.8672 22.9453C50.8203 23.0078 50.7734 23.0625 50.7266 23.1094ZM54.9922 18.2344L57.6641 17.9297C58.0078 19.7422 58.1953 21.2344 58.2266 22.4062L55.4375 22.8281C55.4375 21.4375 55.2891 19.9062 54.9922 18.2344ZM59.75 18.2812L62.4219 17.8359C63.125 19.5391 63.5938 21.0234 63.8281 22.2891L60.9688 22.8516C60.8125 21.5703 60.4062 20.0469 59.75 18.2812ZM64.4844 18.1641L67.2266 17.2969C68.6328 19.2031 69.6406 20.8047 70.25 22.1016L67.3203 23.0859C66.8047 21.8203 65.8594 20.1797 64.4844 18.1641Z" fill="#333333"/>
                <path d="M78.3359 9.09375H88.25C86.4219 7.90625 84.7031 6.45312 83.0938 4.73438C81.7656 6.35938 80.1797 7.8125 78.3359 9.09375ZM82.4141 0.585938L85.1562 1.75781C85.0469 1.96094 84.8906 2.24219 84.6875 2.60156C87.1562 5.28906 90.4219 7.42188 94.4844 9C93.5938 9.79688 92.9609 10.6406 92.5859 11.5312C91.2109 10.8281 90.2109 10.2891 89.5859 9.91406L89.5625 10.2656C89.4219 13.6562 89.1562 15.7344 88.7656 16.5C88.7031 16.6406 88.6328 16.7578 88.5547 16.8516C88.0859 17.3672 87.4062 17.6797 86.5156 17.7891C85.6719 17.8672 84.5156 17.8672 83.0469 17.7891C83.0156 17.0547 82.7891 16.2109 82.3672 15.2578C83.3203 15.3516 84.25 15.3984 85.1562 15.3984C85.5781 15.3828 85.8672 15.2969 86.0234 15.1406C86.2891 14.7969 86.4688 13.6875 86.5625 11.8125H79.0859V18.3984C79.0859 19.0234 79.2422 19.4141 79.5547 19.5703C79.8672 19.7109 80.4688 19.7812 81.3594 19.7812H87.1719C88.0312 19.7812 88.5859 19.5859 88.8359 19.1953C89.1016 18.7891 89.2891 17.9141 89.3984 16.5703C90.1328 17.0547 91.0312 17.4141 92.0938 17.6484C92.1562 17.6484 92.2109 17.6562 92.2578 17.6719C92.0391 19.6875 91.5703 21.0234 90.8516 21.6797C90.1641 22.3047 89 22.6172 87.3594 22.6172H81.1953C79.0703 22.6172 77.6562 22.2734 76.9531 21.5859C76.3438 20.9766 76.0391 19.9219 76.0391 18.4219V10.5938C74.9766 11.1875 74.1641 11.6094 73.6016 11.8594C73.1328 10.9844 72.4609 10.1328 71.5859 9.30469C75.4766 7.77344 78.5547 5.64062 80.8203 2.90625C81.4297 2.15625 81.9609 1.38281 82.4141 0.585938Z" fill="#333333"/>
                </svg>
                </div>
                <div class="backHome" @click="index">
                    <svg t="1782639896211" class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9930" width="200" height="200"><path d="M504.63744 207.9232l-302.6432 313.0368c-3.50208 3.3792-4.68992 8.9088-2.72384 13.76256l0.54272 1.1776c2.2016 4.16768 6.5536 6.83008 11.34592 6.81984H276.48v266.24a10.24 10.24 0 0 0 10.24 10.24h153.6l1.19808-0.07168A10.24 10.24 0 0 0 450.56 808.96V645.12h122.88v163.84a10.24 10.24 0 0 0 10.24 10.24h153.6l1.19808-0.07168A10.24 10.24 0 0 0 747.52 808.96V542.72h65.35168a12.8 12.8 0 0 0 8.88832-22.016L519.36256 207.9232a10.24 10.24 0 0 0-14.72512 0zM512 229.76512L794.76736 522.24H737.28l-1.19808 0.07168A10.24 10.24 0 0 0 727.04 532.48v266.24H593.92V634.88a10.24 10.24 0 0 0-10.24-10.24H440.32l-1.19808 0.07168A10.24 10.24 0 0 0 430.08 634.88v163.84H296.96V532.48l-0.07168-1.19808A10.24 10.24 0 0 0 286.72 522.24h-57.4976L512 229.76512z" fill="#000000" p-id="9931"></path></svg> 返回首页
                </div>
            </div>
            <div class="navs">
                <div class="item active">
                    订单管理
                </div>
                <!-- <div class="item">
                    财务管理
                </div>
                <div class="item">
                    基础信息管理
                </div>
                <div class="item">
                    醒柜管理
                </div> -->
            </div>
        </div>
        <div class="mains">
            <div class="lanmu">
                <div class="top">群接龙</div>
            </div>
            <div class="navWrap">
                <div v-for="(item, index) in ztai" :key="index" class="navItem" :class="{ active: index === currentIndex }" @click="toggleColor(index, item.id)">
                    <div class="item">
                        {{ item.name }}
                    </div>
                    <div v-if="item.id !== 'all'" class="count">
                        {{ item.num }}
                    </div>
                </div>
                <!-- <div class="navItem active">
                    <div class="item">
                        当日已中标
                    </div>
                    <div class="count">
                        0
                    </div>
                </div>
                <div class="navItem">
                    <div class="item">
                        待发货
                    </div>
                    <div class="count">
                        0
                    </div>
                </div>
                <div class="navItem">
                    <div class="item">
                        未到货
                    </div>
                    <div class="count">
                        0
                    </div>
                </div>
                <div class="navItem">
                    <div class="item">
                        已到货
                    </div>
                    <div class="count">
                        0
                    </div>
                </div>
                <div class="navItem">
                    <div class="item">
                        部分到货
                    </div>
                    <div class="count">
                        0
                    </div>
                </div> -->
                <!--<div class="navItem">
                    <div class="item">
                        异常订单
                    </div>
                    <div class="count">
                        0
                    </div>
                </div<div>
                <div class="navItem">
                    <div class="item">
                        退货追单
                    </div>
                    <div class="count">
                        0
                    </div>
                </div>
                <div class="navItem">
                    <div class="item">
                        确认收货
                    </div>
                    <div class="count">
                        0
                    </div>
                </div>
                <div class="navItem">
                    <div class="item">
                        售后
                    </div>
                    <div class="count">
                        0
                    </div>
                </div> -->
                <!-- <div class="navItem">
                    <div class="item">
                        全部订单
                    </div>
                </div> -->
            </div>
            <div class="content flex">
                <div class="contents">
                    <!-- 订单列表 -->
                    <div class="tableWrap">
                        <el-table
                            v-loading="loading"
                            element-loading-text="加载中"
                            :data="tableData"
                            style="width: 100%"
                            height="678">
                            <el-table-column
                            type="index"
                            prop="xuhao"
                            label="序号"
                            width="70">
                            <template slot="header">
                                <div class="filterHeader">
                                    序号
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="taskgrab_id"
                            label="任务ID"
                            width="70">
                            <template slot="header">
                                <div class="filterHeader">
                                    任务ID
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="purchase_order_no"
                            label="采购单号"
                            width="230">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">采购单号</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="external_order_no"
                            label="外部单号"
                            width="230">
                            <template slot="header">
                                <div class="filterHeader">
                                    外部单号
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cate_name"
                            label="类别"
                            width="120">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">类别</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="brand_name"
                            label="品牌"
                            width="120">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">品牌</div>
                            </template>
                            <!-- <template slot="header" slot-scope="scope">
                                <el-popover class="filterHeader"
                                    placement="bottom"
                                    trigger="click">
                                    <div class="pop-wrap">
                                        <div class="cleck-wrap">
                                            <el-input class="btn-search"
                                                placeholder="搜索"
                                                prefix-icon="el-icon-search"
                                                v-model="pinpaikeyInput"
                                                @change="pinpaichangeInput"
                                                clearable
                                                size="small">
                                            </el-input>
                                            <div class="check-box">
                                                <div class="sf scrollBox">
                                                    <el-radio-group v-model="selectedpinpaiRadio" @input="pinpaiInput">
                                                        <el-radio :label="item.brand_id" v-for="item in pinpaiRadio" :key="item.brand_id">{{  item.brand_name }}</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </div>
                                            <div class="footerWrap">
                                                <div class="btnWrap">
                                                    <el-button size="medium" class="nl-need-cancel-btn">取消</el-button>
                                                    <el-button size="medium" class="nl-need-sure-btn">确定</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" style="cursor: pointer;">品牌<svg t="1782501535717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7766" width="200" height="200"><path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z" fill="#666666" p-id="7767"></path></svg></div>
                                </el-popover>
                            </template> -->
                            </el-table-column>
                            <el-table-column
                            prop="goods_name"
                            label="产品型号"
                            width="250">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">产品型号</div>
                            </template>
                            <!-- <template slot="header" slot-scope="scope">
                                <el-popover class="filterHeader"
                                    placement="bottom"
                                    trigger="click">
                                    <div class="pop-wrap">
                                        <div class="cleck-wrap">
                                            <el-input class="btn-search"
                                                placeholder="搜索"
                                                prefix-icon="el-icon-search"
                                                v-model="xinghaokeyInput"
                                                @change="xinghaochangeInput"
                                                clearable
                                                size="small">
                                            </el-input>
                                            <div class="check-box">
                                                <div class="sf scrollBox">
                                                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                                    <el-checkbox-group v-model="selectedxinghaoCheckbox" @change="handleCheckedxinghaoChange">
                                                        <el-checkbox v-for="item in xinghaoCheckbox" :label="item.goods_spec_id" :key="item.goods_spec_id">{{  item.spec_name }}</el-checkbox>
                                                    </el-checkbox-group>
                                                </div>
                                            </div>
                                            <div class="footerWrap">
                                                <div class="btnWrap">
                                                    <el-button size="medium" class="nl-need-cancel-btn">取消</el-button>
                                                    <el-button size="medium" class="nl-need-sure-btn">确定</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" style="cursor: pointer;">产品型号<svg t="1782501535717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7766" width="200" height="200"><path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z" fill="#666666" p-id="7767"></path></svg></div>
                                </el-popover>
                            </template> -->
                            <template slot-scope="scope">
                                <div style="white-space: pre-line; text-align: left;">{{ scope.row.goods_name }}
                                    {{ scope.row.spec_name }}
                                </div>
                            </template>
                            </el-table-column>
                            <!-- <el-table-column
                            prop="task_win_count"
                            label="已成交数量/需求数量"
                            width="300">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    已成交数量/需求数量
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="price-items" style="flex: 3 1 0%; display: flex; align-items: center;">
                                    <div class="vertical_center price-items el-row el-row--flex">
                                        <div class="el-col el-col-12">
                                            <div class="scheduleCont_1_left_1 unborder internal_content" style="height: 1.25rem; border-color: rgb(235, 57, 53);">
                                                <div class="un_xg_1_3_1 internal_content" :style="{width:`${Number((scope.row.task_win_count / scope.row.task_total_num * 100).toFixed(0))}%`}">

                                                </div>
                                            </div>
                                        </div>
                                        <div class="el-col el-col-12" style="text-align: left;">
                                            <span style="margin-left: 5px;">{{ scope.row.task_win_count }}/{{ scope.row.task_total_num }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            </el-table-column> -->
                            <el-table-column
                            prop="price"
                            label="我的出价"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    我的出价
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="need-order-table-content">
                                    <div class="tradePrice">
                                        <div style="margin-top: 5px;"> ￥{{ scope.row.price }} </div>
                                    </div>
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="num"
                            label="出价数量"
                            width="120">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    出价数量
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="arrival_status"
                            label="订单状态"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    订单状态
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="zhuangtai" v-if="scope.row.arrival_status == 0">待发货<el-button size="small" type="primary" @click="fahuo(scope.row)">发货</el-button></div>
                                <div class="zhuangtai" v-if="scope.row.arrival_status == 1">未到货</div>
                                <div class="zhuangtai" v-if="scope.row.arrival_status == 2">部分到货</div>
                                <div class="zhuangtai" v-if="scope.row.arrival_status == 3">已到货</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="resupply_status"
                            label="补交状态"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    补交状态
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="bujiao">{{ scope.row.resupply_text }}<el-button v-if="scope.row.resupply_status == 0 && scope.row.return_qty > 0" size="small" type="primary" @click="buhuo(scope.row)">是否补货</el-button></div>
                                <!-- <div class="bujiao" v-if="scope.row.resupply_status == 0">无需<el-button v-if="scope.row.return_qty > 0" size="small" type="primary" @click="buhuo(scope.row)">是否补货</el-button></div>
                                <div class="bujiao" v-if="scope.row.resupply_status == 1">待补交</div>
                                <div class="bujiao" v-if="scope.row.resupply_status == 2">已完结</div> -->
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="jst_status"
                            label="聚水潭单据状态"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    聚水潭单据状态
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="zhuangtai" v-if="scope.row.jst_status == 'WaitConfirm'">待审核</div>
                                <div class="zhuangtai" v-if="scope.row.jst_status == 'Confirmed'">已确认</div>
                                <div class="zhuangtai" v-if="scope.row.jst_status == 'Finished'">完成</div>
                                <div class="zhuangtai" v-if="scope.row.jst_status == 'Cancelled'">作废</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="payment_voucher"
                            label="付款凭证"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    付款凭证
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="fkimage" v-if="scope.row.arrival_status == 3">
                                    <el-image 
                                        @click="previewImage(scope.row.payment_voucher)"
                                        style="height: 36px"
                                        fit="contain"
                                        :src="scope.row.payment_voucher">
                                        <template v-slot:error>
                                            <div></div>
                                        </template>
                                        <!-- <template v-slot:placeholder>
                                            <div></div>
                                        </template> -->
                                    </el-image>
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="create_time"
                            :formatter="dateFormat"
                            label="出价时间"
                            width="195">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    出价时间
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            fixed="right"
                            prop="status"
                            label="操作"
                            width="175">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    操作
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="caozuo">
                                    <el-button slot="reference" type="danger" size="small" @click="handleDownload(scope.row)">下载送货单</el-button>
                                    <el-button slot="reference" type="primary" size="small" @click="handleDetail(scope.row)">订单详情</el-button>
                                </div>
                            </template>
                            </el-table-column>
                        </el-table>
                        <div class="pageWrap">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="page"
                                :page-sizes="0"
                                :page-size="limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 补货弹窗 -->
        <div class="fahuoDialog">
            <el-dialog title="是否补货" :visible.sync="dialogBuhuoVisible" width="400px" @close="closeBuhuo">
                <el-form>
                    <el-form-item label="补货方式" :label-width="formLabelWidth">
                        <el-radio-group v-model="selectedbuhuoRadio" @input="buhuoInput">
                            <el-radio :label="item.id" v-for="item in buhuoRadio" :key="item.id">{{  item.name }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="bhCancel">取 消</el-button>
                    <el-button type="primary" @click="bhSure">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 发货弹窗 -->
        <div class="fahuoDialog">
            <el-dialog title="确认发货" :visible.sync="dialogFormVisible" width="400px" @close="closeFahuo">
                <el-form>
                    <el-form-item label="配送方式" :label-width="formLabelWidth">
                        <el-radio-group v-model="selectedstatusRadio" @input="statusInput">
                            <el-radio :label="item.id" v-for="item in statusRadio" :key="item.id">{{  item.name }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="wlstatus" label="物流公司" :label-width="formLabelWidth">
                        <el-input v-model="logistics_company" @input="changeGongsi" autocomplete="off" placeholder="请填写物流公司"></el-input>
                    </el-form-item>
                    <el-form-item v-if="wlstatus" label="物流单号" :label-width="formLabelWidth">
                        <el-input v-model="logistics_no" @input="changeDanhao" autocomplete="off" placeholder="请填写物流单号"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="fhCancel">取 消</el-button>
                    <el-button type="primary" @click="fhSure">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 详情弹窗 -->
        <div class="xqDialog">
            <el-dialog title="订单详情" :visible.sync="dialogDetailVisible" width="" @open="openDetail" @close="closeDetail">
                <el-descriptions v-loading="loading" class="margin-top" title="" :column="2" size="" border>
                    <el-descriptions-item>
                        <template slot="label">
                            公司主体
                        </template>
                        {{ company_name }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            出价
                        </template>
                        {{ detail.price }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            数量
                        </template>
                        {{ detail.num }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            仓库
                        </template>
                        {{ warehouse_name }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            状态
                        </template>
                        <div class="status" v-if="detail.status == 1">竞价中</div>
                        <div class="status" v-if="detail.status == 2">已中标</div>
                        <div class="status" v-if="detail.status == 3">已淘汰</div>
                        <div class="status" v-if="detail.status == 4">已撤销</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            采购单号
                        </template>
                        {{ detail.purchase_order_no }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            外部单号
                        </template>
                        {{ detail.external_order_no }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            收货状态
                        </template>
                        {{ detail.receive_status_text }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            到货状态
                        </template>
                        <div class="status" v-if="detail.arrival_status == 0">待发货</div>
                        <div class="status" v-if="detail.arrival_status == 1">未到货</div>
                        <div class="status" v-if="detail.arrival_status == 2">部分到货</div>
                        <div class="status" v-if="detail.arrival_status == 3">已到货</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            到货数量
                        </template>
                        {{ detail.arrival_num }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            物流公司
                        </template>
                        {{ detail.logistics_company }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            物流单号
                        </template>
                        {{ detail.logistics_no }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            收件人
                        </template>
                        {{ detail.receiver_name }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            收件电话
                        </template>
                        {{ detail.receiver_phone }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            送货地址
                        </template>
                        {{ detail.send_address }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            完成日期
                        </template>
                        <div v-if="detail.finish_time">{{ formatDate(detail.finish_time) }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            协议到货
                        </template>
                        <div v-if="detail.delivery_date">{{ formatDate(detail.delivery_date) }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            提交时间
                        </template>
                        <div v-if="detail.create_time">{{ formatDate(detail.create_time) }}</div>
                    </el-descriptions-item>
                </el-descriptions>
            </el-dialog>
        </div>
        <!-- 付款凭证弹窗 -->
        <div class="fkDialog">
            <el-dialog title="付款凭证" :visible.sync="dialogFukuanVisible" width="800px" @open="openFukuan" @close="closeFukuan">
                <el-image 
                    style=""
                    fit="contain"
                    :src="payment_voucher">
                </el-image>
            </el-dialog>
        </div>
    </div>
  </template>

  <script>
    import { myOrderList, downloadDelivery, myQuoteList, cancelQuote, myQuoteBrands, myQuoteSpecs, confirmDelivery, getOrderDetail, confirmResupply, setResupply } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                    //   付款凭证
                    dialogFukuanVisible: false,
                    payment_voucher: '',
                  // 补货弹窗
                  dialogBuhuoVisible: false,
                  buhuoId: '', // 订单id
                  buhuonum: '', // 补货数量
                  buhuoStatusId: '', // 选择状态id
                  selectedbuhuoRadio: '', // 补货方式
                  buhuoRadio: [
                      {
                          id: 0,
                          name: '补货'
                      },
                      {
                          id: 1,
                          name: '完结'
                      }
                ],

                  times: null,
                  dialogFormVisible: false, // 发货弹窗
                  fahuoid: '', // 订单id
                  logistics_company: '',
                  logistics_no: '',
                  selectedstatusRadio: '', // 配送方式
                  statusId: '',
                  statusRadio: [
                      {
                          id: 0,
                          name: '自送'
                      },
                      {
                          id: 1,
                          name: '物流'
                      }
                ],
                wlstatus: false, // 默认物流不显示

                limit: 9, //每页多少数据
                page: 1,
                // 详情弹窗
                dialogDetailVisible: false,
                detail: {},
                company_name: '', // 公司主体
                warehouse_name: '', // 仓库
                // 数据
                tableData: [],
                ztai: [
                    {
                        id: 'today_win',
                        name: '当日已中标',
                        num: '0'
                    },
                    {
                        id: 'pending',
                        name: '待发货',
                        num: '0'
                    },
                    {
                        id: 'ontheway',
                        name: '未到货',
                        num: '0'
                    },
                    {
                        id: 'arrived',
                        name: '已到货',
                        num: '0'
                    },
                    {
                        id: 'partial',
                        name: '部分到货',
                        num: '0'
                    },
                    {
                        id: 'all',
                        name: '全部订单',
                        num: '0'
                    }
                ],
                id: 'today_win', // 默认状态
                currentIndex: 0, // 当前选中项的索引
                // ztid: '', // 切换的状态id

                chexiaoid: '',
                // 数据列表
                loading: false,
                // total: 0,
                // per_page: 10, //每页多少数据
                // page: 1,
                // 品牌搜索框
                pinpaikeyInput: '',
                // 品牌选项
                selectedpinpaiRadio: '',
                pinpaiRadio: [],
                // 型号搜索框
                xinghaokeyInput: '',
                // 型号选项
                checkAll: false,
                isIndeterminate: false,
                selectedxinghaoCheckbox: [],
                xinghaoCheckbox: [],
                
                // 额度搜索框
                edukeyInput: '',
                // 额度选项
                selectededuRadio: '',
                eduRadio: [
                    {
                        id: 1,
                        name: 'T+2',
                        num: '4'
                    }
                ],
                // 时效搜索框
                shixiaokeyInput: '',
                // 时效选项
                selectedshixiaoRadio: '',
                shixiaoRadio: [
                    {
                        id: 1,
                        name: '当日 24:00'
                    },
                    {
                        id: 2,
                        name: '次日 24:00'
                    },
                    {
                        id: 3,
                        name: '后日 24:00'
                    },
                    {
                        id: 4,
                        name: '3日后到货'
                    },
                    {
                        id: 5,
                        name: '已过到货时效'
                    }
                ],

                form:{},
                values: '' // 出价数量

              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            methods: {

                // 返回列表
                index(){
                    this.$router.replace("/")
                },

                // 订单
                myOrderList(id){
                    this.loading = true;
                    myOrderList({
                        tab: id,
                        date: '',
                        delivery_date: '',
                        page: this.page,
                        limit: this.limit,
                        force_sync: '1'
                    }).then((res) => {
                        console.log(res);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total;
                            this.ztai[0].num = res.data.data.tab_stats.today_win; // 当日以中标
                            this.ztai[1].num = res.data.data.tab_stats.pending; // 待发货
                            this.ztai[2].num = res.data.data.tab_stats.ontheway; // 未到货
                            this.ztai[3].num = res.data.data.tab_stats.arrived; // 已到货
                            this.ztai[4].num = res.data.data.tab_stats.partial; // 部分到货
                            // this.total = res.data.data.total // 数据总条数
                        }
                    });
                },

                // 付款凭证弹窗
                previewImage(val){
                    this.dialogFukuanVisible = true;
                    this.payment_voucher = val;
                },
                closeFukuan(){
                    this.payment_voucher = ''
                },

                // 补货
                buhuo(row){
                    this.dialogBuhuoVisible = true;
                    this.buhuoid = row.id; // 订单id
                    this.buhuonum = row.return_qty // 补货数量
                    // this.myOrderList()
                },

                // 关闭弹窗回调
                closeBuhuo(){
                    // this.logistics_company = '',
                    // this.logistics_no = '',
                    this.selectedbuhuoRadio = ''
                },

                bhCancel(){
                    this.dialogBuhuoVisible = false
                },

                // 获取补货方式值
                buhuoInput(){
                    const selectedbuhuoItem = this.buhuoRadio.find(item => item.id === this.selectedbuhuoRadio); // 获取选中项的详细信息
                    this.buhuoStatusId = this.selectedbuhuoRadio;
                    // if(this.buhuoStatusId == 1){
                    //     this.wlbuhuo = true
                    // }else{
                    //     this.wlbuhuo = false
                    // }
                    console.log("id=" + this.selectedbuhuoRadio)
                    console.log("文字：", selectedbuhuoItem) // 获取选中项的详细信息，例如 name 和 id
                },

                bhSure(){
                    if (this.selectedbuhuoRadio === ''){
                        this.$message.error('请选择是否补货');
                        return
                    }if(this.buhuoStatusId == 0){
                        // 补货
                        this.dialogBuhuoVisible = false;
                        // this.selectedbuhuoRadio = ''
                        this.setResupply(this.buhuoid,'resupply')
                    }else{
                        // 完结
                        // console.log('自送')
                        this.dialogBuhuoVisible = false;
                        this.setResupply(this.buhuoid,'finish')
                    }
                },

                // 补货
                // confirmResupply(id,num) {
                //     // this.loading = true;
                //     confirmResupply({
                //         id: id,
                //         arrival_num: num
                //     }).then((res) => {
                //         // console.log(res);
                //         // this.loading = false;
                //         if (res.data.code == 1) {
                //             this.myOrderList();
                //             this.selectedbuhuoRadio = '';
                //             this.$message({
                //                 type: 'success',
                //                 message: '确认补货成功'
                //             });
                //         }else{
                //             this.$message.error(res.data.msg);
                //         }
                //     });
                // },

                // 完结
                setResupply(id,action) {
                    // this.loading = true;
                    setResupply({
                        id: id,
                        action: action
                    }).then((res) => {
                        // console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.myOrderList();
                            this.selectedbuhuoRadio = '';
                            this.$message.success(res.data.msg);
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    });
                },

                // 发货
                fahuo(row){
                    this.dialogFormVisible = true;
                    this.fahuoid = row.id
                    // this.myOrderList()
                },

                // 关闭弹窗回调
                closeFahuo(){
                    this.logistics_company = '',
                    this.logistics_no = '',
                    this.selectedstatusRadio = '',
                    this.wlstatus = false
                },

                fhCancel(){
                    this.dialogFormVisible = false,
                    this.logistics_company = '',
                    this.logistics_no = ''
                },

                // 获取配送方式值
                statusInput(){
                    const selectedstatusItem = this.statusRadio.find(item => item.id === this.selectedstatusRadio); // 获取选中项的详细信息
                    this.statusId = this.selectedstatusRadio;
                    if(this.statusId == 1){
                        this.wlstatus = true
                    }else{
                        this.wlstatus = false
                    }
                    console.log("id=" + this.selectedstatusRadio)
                    console.log("文字：", selectedstatusItem) // 获取选中项的详细信息，例如 name 和 id
                },

                fhSure(){
                    if (this.selectedstatusRadio === ''){
                        this.$message.error('请选择配送方式');
                        return
                    }if(this.statusId == 1){
                        if (this.logistics_company === '') {
                            this.$message.error('请填写物流公司');
                            return
                        }if (this.logistics_no === '') {
                            this.$message.error('请填写物流单号');
                            return
                        }else{
                            // console.log('物流')
                            this.dialogFormVisible = false;
                            // this.selectedstatusRadio = ''
                            this.confirmDelivery(this.fahuoid)
                        }
                    }else{
                        // console.log('自送')
                        this.dialogFormVisible = false;
                        this.confirmDelivery(this.fahuoid)
                    }
                },

                changeGongsi(val){
                    this.logistics_company = val
                    // console.log(val)
                },

                changeDanhao(val){
                    this.logistics_no = val
                    // console.log(val)
                },

                // 确认发货
                confirmDelivery(id){
                    // this.loading = true;
                    confirmDelivery({
                        id: id,
                        sfstatus: this.statusId,
                        logistics_company: this.logistics_company,
                        logistics_no: this.logistics_no
                    }).then((res) => {
                        console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.myOrderList();
                            this.logistics_company = '',
                            this.logistics_no = '';
                            this.$message({
                                type: 'success',
                                message: '确认发货成功'
                            });
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    });
                },

                // 下载送货单
                downloadDelivery(id){
                    const link = document.createElement('a');
                    link.href = 'http://qdpc.jhwl.ink/api/quote/downloadDelivery?id=' + id;
                    link.setAttribute('download', ''); // 建议设置 download 属性强制下载而非预览
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    // downloadDelivery({
                    //     params: {
                    //         id: id
                    //     }
                    // }).then((res) => {
                    //     // console.log(res.data.data);
                    //     if (res.data.code == 1) {
                    //         // this.tableData = res.data.data.list;
                    //         // this.total = res.data.data.total // 数据总条数
                    //     }
                    // });
                },
                handleDownload(row){
                    this.downloadDelivery(row.id)
                },

                // 订单详情
                handleDetail(row){
                    this.dialogDetailVisible = true;
                    // this.loading = true;
                    this.getOrderDetail(row.id);
                },

                getOrderDetail(id) {
                    // this.loading = true;
                    getOrderDetail({
                        id: id
                    }).then((res) => {
                        // console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.detail = res.data.data.bid;
                            this.company_name = res.data.data.company_name;
                            this.warehouse_name = res.data.data.warehouse_name
                        }
                    });
                },
                closeDetail(){
                    // this.detail = '';
                    // this.company_name = '';
                    // this.warehouse_name = ''
                },
                // openDetail(){
                //     this.$nextTick(() => {
                //         this.loading = true // 或 setTimeout(() => { this.loading = true }, 0)
                //     })
                // },
                // closeDetail(){
                //     this.$nextTick(() => {
                //         this.loading = false // 或 setTimeout(() => { this.loading = true }, 0)
                //     })
                // },
                
                // 状态切换
                toggleColor(index, id) {
                    this.currentIndex = index;
                    this.page = 1;
                    this.ztid = id;
                    this.myOrderList(id)
                },

                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(page) {
                    // console.log(`当前页: ${page}`);
                    this.loading = true;
                    myOrderList({
                        // tab: this.ztid,
                        // date: '',
                        // delivery_date: '',
                        page: page,
                        limit: this.limit
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.list;
                        }
                    });
                },

                // 品牌筛选
                pinpaiInput(){
                    const selectedpinpaiItem = this.pinpaiRadio.find(item => item.brand_id === this.selectedpinpaiRadio); // 获取选中项的详细信息
                    console.log("id=" + this.selectedpinpaiRadio)
                    console.log("文字：", selectedpinpaiItem) // 获取选中项的详细信息，例如 name 和 id
                },
                // 品牌下拉数据
                myQuoteBrands(){
                    myQuoteBrands({}).then((res) => {
                        console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.pinpaiRadio = res.data.data;
                            // this.total = res.data.data.total // 数据总条数
                        }
                    });
                },

                // 型号筛选 全选
                handleCheckAllChange(val) {
                    if (val) {
                        this.selectedxinghaoCheckbox = this.xinghaoCheckbox.map(item => item.goods_spec_id); // 选中所有项的 ID
                        this.isIndeterminate = false;
                        console.log(this.selectedxinghaoCheckbox)
                    } else {
                        this.selectedxinghaoCheckbox = []; // 清除所有选中项
                    }
                },
                // 多选
                handleCheckedxinghaoChange(value) {
                    // 处理选中项变化的情况，例如更新全选状态等。
                    let checkedCount = value.length;
                    this.checkAll = checkedCount === this.xinghaoCheckbox.length; // 根据选中项更新全选状态
                    this.isIndeterminate = checkedCount > 0 && checkedCount < this.xinghaoCheckbox.length;
                    console.log(JSON.stringify(this.selectedxinghaoCheckbox)) // 输出[1, 2]
                    console.log(this.selectedxinghaoCheckbox.join(',')) // 输出1, 2
                },
                // 型号下拉数据
                myQuoteSpecs(){
                    myQuoteSpecs({}).then((res) => {
                        console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.xinghaoCheckbox = res.data.data;
                            // this.total = res.data.data.total // 数据总条数
                        }
                    });
                },

                // 额度筛选
                eduInput(){
                    const selectededuItem = this.eduRadio.find(item => item.id === this.selectededuRadio); // 获取选中项的详细信息
                    console.log("id=" + this.selectededuRadio)
                    console.log("文字：", selectededuItem) // 获取选中项的详细信息，例如 name 和 id
                },

                // 出价记录
                myQuoteList() {
                    // this.loading = true;
                    myQuoteList({}).then((res) => {
                        console.log(res);
                        // this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data;
                            this.total = res.data.data.total
                            // this.total = res.data.data.total // 数据总条数
                        }
                    });
                },

                // 撤销出价
                handleChexiao(row){
                    // console.log(row.id)
                    this.chexiaoid = row.id
                },
                handleChujia(){
                    cancelQuote({
                        ids: this.chexiaoid
                    }).then(res => {
                        // console.log(res);
                        if (res.data.code == 1) {
                            // this.page = 1;
                            this.$message({
                                type: 'success',
                                message: '撤销出价成功'
                            });
                            this.myQuoteList(); // 调用出价记录
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                },


                // 日期范围回显
                changeDate(e) {
                    console.log(e[0], e[1]);
                    this.start_time = e[0]; // 开始日期
                    this.end_time = e[1]; // 结束日期
                },
                // 列表
                contractEntrustIndex() {
                    this.loading = true;
                    contract_entrust_index({
                        params: {
                            type: 'material'
                        }
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                            this.total = res.data.data.total // 数据总条数
                        }
                    });
                },
                // 委托单位列表
                basisEntrustIndex() {
                    this.loading = true;
                    basis_entrust_index().then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.danweiList = res.data.data.data;
                        }
                    });
                },
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            
                        var val = this.multipleSelection;
                        var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串

                        contract_entrust_del({
                            ids: multipleSelection
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.contractEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });

                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.formInline.name);
                            this.loading = true;
                            contract_entrust_index({
                                params: {
                                    type: 'material',
                                    entrust_id: this.formInline.entrust_id,
                                    serial: this.formInline.serial,
                                    entrust_phone: this.formInline.entrust_phone,
                                    start_time: this.start_time,
                                    end_time: this.end_time,
                                    page: this.page
                                }
                            }).then((res) => {
                                // console.log(res.data.data);
                                this.loading = false;
                                if (res.data.code == 1) {
                                    this.tableData = res.data.data.data;
                                    this.total = res.data.data.total // 数据总条数
                                }
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    // var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串
                    // console.log(multipleSelection)
                },
                // 行数据查看跳转任务单
                handleSee(row) {
                    console.log(row);
                },
                // 行数据查看
                handleClick(row) {
                    console.log(row);
                },
                // 行数据编辑
                handleEdit(row) {
                    console.log(row);
                },
                // 行数据删除
                handleDelete(row) {
                    // console.log(row.id);
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {

                        contract_entrust_del({
                            ids: row.id
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.contractEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                // handleCurrentChange(page) {
                //     // console.log(`当前页: ${page}`);
                //     this.loading = true;
                //     contract_entrust_index({
                //         params: { page }
                //     }).then((res) => {
                //         // console.log(res.data.data);
                //         this.loading = false;
                //         if (res.data.code == 1) {
                //             this.tableData = res.data.data.data;
                //         }
                //     });
                // },
                // 时间戳转日期格式
                formatDate(timestamp) {
                    const date = new Date(timestamp * 1000);
                    return date.toLocaleString(); // 或者使用其他格式化方法，如 date.toLocaleString() 或其他库如 moment.js
                },
                dateFormat(row) {
                    let data = row.create_time * 1000
                    let dtime = new Date(data)
                    const year = dtime.getFullYear()
                    let month = dtime.getMonth() + 1
                    if (month < 10) {
                        month = '0' + month
                    }
                    let day = dtime.getDate()
                    if (day < 10) {
                        day = '0' + day
                    }
                    let hour = dtime.getHours()
                    if (hour < 10) {
                        hour = '0' + hour
                    }
                    let minute = dtime.getMinutes()
                    if (minute < 10) {
                        minute = '0' + minute
                    }
                    let second = dtime.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    return year+ '-' + month+ '-' + day + ' ' + hour + ':' + minute + ':' + second
                }
            },
            created() {
                this.myOrderList(this.id); // 订单
                // 实现轮询
                this.times = setInterval(() => {
                    this.myOrderList(this.ztid);
                }, 1000 * 60);

                // this.myQuoteList(); // 出价记录
                // this.myQuoteBrands(); // 我的出价品牌列表
                // this.myQuoteSpecs(); // 我的出价产品型号列表
                // this.contractEntrustIndex(); // 列表
                // this.basisEntrustIndex() // 委托单位列表
            },
            destroyed() {
                //销毁 clearInterval(this.times);
                clearInterval(this.times);
                // this.timer = null;
            },
            // 解决表格fixed错位问题
            updated() {
                if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
                    this.$refs.singleTable.doLayout()
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
      .ystatus{
        width: 100%;
        text-align: center;
        color: #847f7f;
        cursor: default;
      }
      .wstatus{
        width: 100%;
      }
      .mains{
          border-radius: 5px;
      }
      .lanmu{
            /* width: 100%; */
            background: rgba(255, 255, 255, .8);
            border-radius: 10px;
            padding: 0 10px 0 40px;
            margin-bottom: 0;
      }
      .lanmu .top{
            display: inline-block;
            background: #fff6f6;
            width: 100px;
            text-align: center;
            line-height: 30px;
            border-bottom: 2px solid #eb3935;
            color: #000;
      }
      .sub{
          margin-top: 5px;
          gap: 12px;
      }
      .sub p{
          width: 160px;
          color: #7d7d7d;
          flex: 0 0 auto;
      }
      .caidan{
          flex: 1;
          /* margin-left: 20px;
          width: calc(100% - 135px); */
      }
      .caidan .cons li{
            line-height: 22px;
            padding: 3px 16px;
            border-radius: 6px;
            margin-right: 20px;
            cursor: pointer;
            color: #000;
            font-size: 14px;
      }
      .caidan .cons li.active{
          background: #eb3935;
          color: #fff;
      }
      .content{
          height: calc(100% - 86px);
        align-items: flex-start;
        gap: 12px;
      }
      .xuanx{
          width: 200px;
        background: #fff;
        height: 100%;
        border-radius: 10px;
        flex: 0 0 auto;
      }
      .xuanx .luodi{
          padding-bottom: 7px;
          margin: 0 24px;
            padding: 20px 0 10px;
            font-size: 14px;
            color: #666;
          border-bottom: 1px solid #e7e7e7;
      }
      .xuanx .luodi img{
          margin-right: 8px;
      }
      .sf .el-radio-group{
          width: 100%;
          padding: 10px 0;
      }
      .contents{
          /* margin-left: 20px;
        width: calc(100% - 155px); */
        height: 100%;
        /* border-radius: 10px; */
        flex: 1;
        overflow: hidden;
      }
      .caidans{
          margin-bottom: 16px;
          border-radius: 10px;
          /* background: #fff; */
          display: flex;
      }
      .caidans .plei{
          background: #fff;
          border-radius: 10px;
          flex: 1;
          margin-right: 12px;
      }
      .pro{
          border-radius: 10px;
          background: #fff;
          padding: 0 15px;
          height: calc(100% - 75px);
        overflow-y: scroll;
      }
      .pro .bt{
          display: inline-flex;
          padding-bottom: 20px;
          border-bottom: 1px solid #dfe6ec;
          position: sticky;
        top: 0;
        background: #fff;
        padding-top: 15px;
      }
      .pro .bt li{
          margin-right: 10px;
        background: #f8f8f8;
        border: 1px solid #e7e7e7;
        line-height: 50px;
        width: 164px;
        text-align: center;
        border-radius: 10px;
        box-sizing: border-box;
      }
      .pro .bt li:nth-child(2),
      .bcon .list li:nth-child(2){
          width: 360px;
      }
      .pro .bt li:nth-child(3),
      .bcon .list li:nth-child(3){
          width: 180px;
      }
      .pro .bt li:nth-child(4),
      .bcon .list li:nth-child(4){
          width: 554px;
      }
      .pro .bt li:nth-child(5),
      .bcon .list li:nth-child(5){
          width: 180px;
      }
      .pro .bt li:nth-child(6),
      .bcon .list li:nth-child(6){
          width: 180px;
      }
      .pro .bt li:nth-child(7),
      .bcon .list li:nth-child(7){
          width: 200px;
      }
      .pro .bt li:nth-child(8),
      .bcon .list li:nth-child(8){
          width: 400px;
      }
      .pro .bt li:nth-child(9),
      .bcon .list li:nth-child(9){
          width: 200px;
      }
      .pro .bt li:nth-child(10),
      .bcon .list li:nth-child(10){
          width: 240px;
      }
      .pro .bt li:nth-child(11),
      .bcon .list li:nth-child(11){
          width: 320px;
      }
      .pro .bt li:nth-child(12),
      .bcon .list li:nth-child(12){
          width: 400px;
          margin-right: 0;
      }
      .bcon{
          display: inline-block;
      }
      .bcon .list{
          padding: 20px 0;
          border-bottom: 1px solid #dfe6ec;
          font-size: 14px;
      }
      .bcon .list li{
          margin-right: 10px;
          width: 164px;
          text-align: center;
      }
      .bcon .list li:nth-child(2){
          text-align: left;
        white-space: pre-line;
        line-height: 25px;
      }
      .bcon .list li.t0{
          display: flex;
          align-items: center;
          justify-content: center;
      }
      .bcon .list li.t0 span{
          width: 15px;
        height: 15px;
        background: #03cc06;
        border-radius: 50%;
        margin-right: 5px;
      }
      .bcon .jl{
          justify-content: flex-end;
      }
      .bcon .jl .btns{
          background: #df3632;
          width: 80px;
          line-height: 40px;
          color: #fff;
          border-radius: 5px;
          margin-left: 30px;
          cursor: pointer;
      }
      .bcon .jl .tiao{
          width: 120px;
        line-height: 25px;
        background: #ffdfdf;
        height: 25px;
        border-radius: 5px;
        overflow: hidden;
      }
      .bcon .jl .tiao p{
          background: #eb3935;
          height: 100%;
      }
      .bcon .date{
          border: 1px solid #eb3935;
          color: #eb3935;
        line-height: 40px;
        border-radius: 5px;
      }
      .bcon .tip p{
          white-space: pre-line;
        line-height: 25px;
      }
      .bcon .time{
          background: #eb3935;
          color: #fff;
        line-height: 32px;
        border-radius: 5px;
      }
      .bcon .list li:last-child{
          text-align: left;
          line-height: 25px;
      }
      .caidans .cons{
          padding: 10px 15px;
      }
      .caidans .cons li{
          line-height: 20px;
        padding: 3px 12px;
        border-radius: 4px;
        margin-right: 25px;
        cursor: pointer;
        color: #666;
        font-size: 14px;
        border: 1px solid #e7e7e7;
        max-width: 280px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .caidans .cons li.active{
          background: #eb3935;
        color: #fff;
      }
      .sf .radiogroup{
          width: 100%;
      }
      .sf label{
          position: relative;
          margin: 0;
        padding: 8px 0 8px 24px;
        display: flex;
        height: 20px;
      }
      .sf label.is-checked{
          background: #fff6f6;
      }
      .sf label.is-checked:after{
          content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 6px;
        height: 100%;
        background: #eb3935;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
      .sf /deep/ .el-radio__label{
          padding-left: 12px;
          color: #7c7c7c;
          line-height: 20px;
      }
      .sf /deep/ .el-radio__inner{
          border: 1px solid #dcdfe6;
            width: 20px;
            height: 20px;
            border-radius: 2px;
      }
      .sf /deep/ .el-radio__input.is-checked .el-radio__inner{
          border-color: #eb3935;
        background-color: #eb3935;
      }
      .sf /deep/ .el-radio__inner::after{
          -webkit-box-sizing: content-box;
            box-sizing: content-box;
            content: "";
            border: 2px solid #fff;
            background: transparent;
            border-radius: 0;
            outline: none;
            border-left: 0;
            border-top: 0;
            height: 10px;
            left: 6px;
            position: absolute;
            top: 1px;
            -webkit-transform: rotate(45deg) scaleY(0);
            transform: rotate(45deg) scaleY(0);
            width: 4px;
            -webkit-transition: -webkit-transform .15s ease-in .05s;
            transition: -webkit-transform .15s ease-in .05s;
            transition: transform .15s ease-in .05s;
            transition: transform .15s ease-in .05s, -webkit-transform .15s ease-in .05s;
            -webkit-transform-origin: center;
            transform-origin: center;
      }
      .sf /deep/ .el-radio__input.is-checked .el-radio__inner::after{
          -webkit-transform: rotate(45deg) scaleY(1);
        transform: rotate(45deg) scaleY(1);
        transition: none;
      }
      .jldialog /deep/ .el-dialog__title{
          font-weight: bold;
      }
      .jldialog /deep/ .el-dialog__header{
          padding: 0;
          text-align: center;
          line-height: 80px;
          background: #ffdd00;
          color: #000;
      }
      .jldialog .list{
          flex-wrap: wrap;
          padding: 6px 0 11px;
      }
      .jldialog .list div{
          width: 50%;
          margin-bottom: 2px;
      }
      .jldialog .list div:last-child{
          width: 100%;
      }
      .jldialog .name{
          padding-bottom: 11px;
        border-bottom: 1px solid #e7e7e7;
        color: #000;
        font-size: 16px;
      }
      .jldialog .xx{
          padding: 10px;
        background: #f8f8f8;
        border-radius: 5px;
      }
      .jldialog .canyu{
          padding: 10px;
          border-radius: 5px;
          margin: 10px 0;
          background: #f8f8f8;
      }
      .jldialog .canyu .line{
          height: 15px;
          background: #ffdfdf;
          display: block;
          margin: 5px 0;
      }
      .jldialog .canyu .tt{
          text-align: center;
          color: #000;
          justify-content: center;
          align-items: center;
      }
      .jldialog .chujia{
          background: #f8f8f8;
          min-height: 134px;
          border-radius: 5px;
      }
      .jldialog .chujia .zanwu{
          line-height: 134px;
          text-align: center;
      }
      .jldialog .bd{
          margin-top: 6px;
          justify-content: space-between;
      }
      .jldialog .bd button{
          outline: none;
          box-shadow: none;
          width: 200px;
          line-height: 54px;
          border-radius: 5px;
          text-align: center;
          background: #f59c9a;
          color: #fff;
          font-size: 18px;
          border: 0;
          cursor: pointer;
      }
      .jldialog .bd .top{
          margin-bottom: 10px;
          justify-content: space-between;
      }
      .jldialog .bd .input{
          width: 452px;
      }
      .jldialog .bd input{
          width: 155px;
        border: 0;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        line-height: 40px;
        padding: 0 15px;
        color: #606266;
      }
      .jldialog .bd .bot .el-select{
          flex: 1;
      }
      .tableWrap {
        padding: 12px;
        background: #fff;
        border-radius: 6px;
        position: relative;
        z-index: 0;
        height: calc(100% - 24px);
    }
    /* 基础滚动条样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar{
        width: 8px;
        height: 8px;
    }
    /* 轨道样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {
        background: #F1F1F1;
        border-radius: 10px;
    }
    /* 滑块样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
    }
    /* 悬停效果 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
    .cleck-wrap .btn-search{
        margin-bottom: 10px;
    }
    .cleck-wrap .check-box {
        border-radius: 3px;
        border: 1px solid #e4e7ed;
        padding: 5px 0;
        font-weight: 400;
    }
    .scrollBox{
        max-height: 220px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .scrollBox .el-radio-group{
        padding: 0;
    }
    .scrollBox label{
        height: 26px;
        padding: 0 10px;
        align-items: center;
    }
    .scrollBox /deep/ .el-radio__inner{
        width: 14px;
        height: 14px;
        border-radius: 2px;
    }
    .scrollBox label.is-checked{
        background-color: #f5f7fa;
      }
      .scrollBox label.is-checked:after{
          display: none;
      }
      .scrollBox /deep/ .el-radio__inner::after{
          width: 3px;
          height: 8px;
          left: 4px;
          border-width: 1px;
      }
      .scrollBox /deep/ .el-radio__label{
          color: #606266;
      }
      .footerWrap{
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
      }
      .footerWrap .btnWrap .el-button{
          font-size: 14px;
          padding: 7px 21px;
      }
      .footerWrap .btnWrap .el-button:hover{
          background: #f8f8f8;
          color: #333;
          border-color: #e7e7e7;
      }
      .footerWrap /deep/ .nl-need-cancel-btn{
          background: #f8f8f8;
        border-color: #e7e7e7;
        color: #333;
      }
      .footerWrap /deep/ .nl-need-sure-btn{
          background: #eb3935;
        border-color: #eb3935;
        color: #fff;
      }
      .footerWrap .btnWrap .el-button.nl-need-sure-btn:hover{
          background: #eb3935;
        border-color: #eb3935;
        color: #fff;
      }
      .companyCredit {
        vertical-align: -.15em;
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 8px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin-right: 4px;
        background: #03cc06;
    }
    .orders_price{
        display: flex;
        align-items: center;
        justify-content: right;
    }
    .orders_price .item{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #0e86eb;
        color: #0e86eb;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customProgress {
        width: 180px;
        font-size: 14px;
        color: #333;
        margin-left: 6px;
    }
    .unborder {
        border: none;
        background-color: #ffdfdf;
    }
    .scheduleCont_1_left_1 .un_xg_1_3_1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        border-radius: 3px;
        background-image: -webkit-gradient(linear, left top, right top, from(#eb3935));
        background-image: linear-gradient(90deg, #eb3935);
    }
    .scheduleCont_1_left_1{
        position: relative;
        width: 100%;
        height: .8rem;
        border-radius: 3px;
        overflow: hidden;
    }
    .btnPickDragon {
        width: 68px;
        height: 30px;
        font-size: 14px;
        color: #fff;
        padding: 4px 2px;
        border-radius: 4px;
        border: 0;
        background-color: #eb3935;
    }
    .border-time{
        padding: 4px;
        border-radius: 6px;
        border: 1px solid #eb3935;
        text-align: center;
        color: #eb3935;
    }
    .limitTime {
        font-size: 14px;
        line-height: 22px;
        color: rgb(255, 255, 255);
        text-align: center;
        background-color: rgb(204, 204, 204);
        padding: 0px;
        border-radius: 4px;
        margin: 0px auto;
        background-color: rgb(235, 87, 50);
    }
    .el-table{
        color: #333;
    }
    /deep/ .el-table .cell{
        text-align: center;
    }
    /deep/ .el-table__header th.el-table__cell{
        padding: 0 0 12px;
    }
    /deep/ .el-table th.el-table__cell>.cell{
        padding-left: 4px;
        padding-right: 4px;
    }
    /deep/ .el-table th.el-table__cell>.cell .filterHeader{
        padding-left: 4px;
        padding-right: 4px;
        height: 42px;
        line-height: 42px;
        background-color: #f8f8f8;
        border-radius: 6px;
        border: 1px solid #e7e7e7;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 14px;
        font-weight: 400;
    }
    /deep/ .el-table th.el-table__cell>.cell .filterHeader .icon{
        width: 1em;
        height: 1em;
        display: inline-block;
        vertical-align: text-bottom;
        margin-left: 4px;
    }
    .scrollBox /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
        color: inherit;
    }
    .scrollBox /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .scrollBox /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #eb3935;
        border-color: #eb3935;
    }
    .tableTop{
        margin: 12px 0;
    }
    .tableTop .text_top{
        margin-left: 10px;
        font-size: 14px;
        color: #666;
    }
    .pageWrap{
        text-align: right;
        margin: 7px 10px 0 0;
    }
    .tableWrap .price-items {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        display: inline-block;
        padding: 2px 5px;
        margin: 3px 5px 3px 3px;
        border-radius: 3px;
        width: 190px;
    }
    .tableWrap .need-order-table-content{
        display: inline-block;
        white-space: nowrap;
    }
    .tableWrap .need-order-table-content .tradePrice {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        width: 70px;
        height: 30px;
        font-weight: 700;
        color: #eb3935;
        background-color: #f8f8f8;
        border-radius: 4px;
    }
    .tableWrap .need-order-table-content div, .tableWrap .need-order-table-content span {
        white-space: nowrap;
    }
    /deep/ .dd, /deep/ .lanmu{
        display: none;
    }
    /deep/ .mains{
        margin-top: 0;
    }
    .header{
        --red: #eb3935;
        --bg: #fd0;
        --light: #ffee7b;
        background: #fff;
        padding: 0 60px;
        gap: 40px;
        -webkit-box-sizing: unset;
        box-sizing: unset;
        background: linear-gradient(135deg, var(--bg) 30%, var(--light) 34%, var(--light) 38%, var(--bg) 42%, var(--bg) 48%, var(--light) 52%, var(--light) 56%, var(--bg) 60%);
        background: #5bcee1;
    }
        .header .newLogo, .header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .header .newLogo {
        gap: 8px;
    }
    .header .newLogo .icon {
        /* width: 38px; */
        cursor: pointer;
        display: flex;
    }
    .header .newLogo .icon img{
        height: 68px;
    }
    .header .newLogo svg {
        display: block;
        width: 100%;
    }
    .header .newLogo .text {
        width: 82px;
        cursor: pointer;
        display: none;
    }
    .header .newLogo .backHome {
        display: flex;
        cursor: pointer;
        background-color: hsla(0, 0%, 100%, .6);
        padding: 2px 12px;
        font-size: 14px;
        line-height: 24px;
        border-radius: 30px;
    }
    .svg-icon {
        width: 1em!important;
        height: 1em;
        vertical-align: -.15em;
        fill: currentColor;
        overflow: hidden;
        font-size: 23px;
    }
    .header .navs {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: auto;
    }
    .header .navs .item {
        width: 196px;
        padding: 21px 0;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        text-align: center;
        font-size: 16px;
        line-height: 1.5;
        color: #333;
        font-weight: 500;
    }
    .header .navs .item.active {
        border-bottom-color: #eb3935;
        background: rgba(235, 57, 53, .1);
    }
    .navWrap .navItem {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        max-width: 120px;
        padding: 12px 0;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        font-size: 0;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }
    .navWrap .navItem, .navWrap {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        border-radius: 8px;
    }
    .navWrap .navItem .item {
        font-size: 16px;
        line-height: 22px;
        color: #333;
        -webkit-transition: all .1s ease-out;
        transition: all .1s ease-out;
    }
    .navWrap .navItem .count {
        height: 20px;
        padding: 0 1em;
        font-size: 14px;
        font-weight: 500;
        color: #eb3935;
        line-height: 20px;
        border-radius: 10px;
        background-color: #e7e7e7;
        -webkit-transition: all .3s ease-in-out;
        transition: all .3s ease-in-out;
    }
    .navWrap .navItem:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 80%;
        height: 6px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        border-radius: 5px 5px 0 0;
    }
    .navWrap .navItem.active:after {
        background-color: #eb3935;
    }
    .navWrap{
        border-radius: 8px 8px 0 0;
        margin: 7px 0 7px 0;
        background: #fff;
    }
    .mains{
        height: calc(100vh - 113px);
    }
    .tableWrap .zhuangtai, .tableWrap .bujiao{
        gap: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tableWrap .bujiao .el-button{
        padding: 9px;
    }
    .fahuoDialog /deep/ .el-form-item{
        display: flex;
    }
    .fahuoDialog /deep/ .el-form-item__content{
        flex: 1;
    }
    .tableWrap .caozuo{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .tableWrap .caozuo /deep/ .el-button--small{
        padding-left: 8px;
        padding-right: 8px;
    }
    .xqDialog /deep/ .el-dialog__body{
        padding-top: 15px;
    }
    .xqDialog /deep/ .el-descriptions-row td{
        /* min-width: 203.27px; */
    }
    .tableWrap .fkimage{
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    /* .tableWrap .fkimage /deep/ .el-image__inner{
        object-fit: contain;
    } */
    .fkDialog .el-image{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 500px;
    }
    .fkDialog .el-image /deep/ .el-image__inner{
        width: auto;
        height: auto;
        max-height: 500px;
    }
  </style>


// WEBPACK FOOTER //
// src/components/order.vue